// Presentation descriptors keep ongoing operations independent of locale. Resolve
// them only while rendering, never use translated copy as workflow identity.
export const memberMessage = (key, values) => ({ key, values })
export const renderMemberMessage = (t, value) => value && typeof value === 'object' && value.key ? t(value.key, value.values) : value
